let russianAllowed = false

export const setRussianAllowed = (value) => {
  russianAllowed = !!value
}

export const getLanguages = () => [
  { value: "ua", label: "Ukrainian" },
  ...(russianAllowed ? [{ value: "ru", label: "Russian" }] : []),
  { value: "en", label: "English" },
]

export const getTranslateDirs = () => [
  ...(russianAllowed
    ? [
        { value: "RU_UA", label: "RU → UA" },
        { value: "UA_RU", label: "UA → RU" },
      ]
    : []),
  { value: "UA_EN", label: "UA → EN" },
  { value: "EN_UA", label: "EN → UA" },
]
